module.exports = __webpack_public_path__ + "10388fa20cd945937d4a4cbe3ffc16ad.png";